import React, { useState, useEffect } from "react";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import CustomUploadAdapterPlugin from "../../../../components/admin/ckeditor/UploadAdapter";

const EditPost = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [categories, setCategories] = useState([]);
  const [formData, setFormData] = useState({
    title: "",
    description: "",
    image: "",
    date: "",
    category_id: "",
    status: "",
  });

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await axios.get(`/api_w/postcategories`, {
          headers: {
            db_name: process.env.REACT_APP_DB_NAME,
          },
        });
        setCategories(response.data.data);
      } catch (error) {
        toast.error(
          "Error fetching kategori: " +
            (error.response?.data?.message || error.message)
        );
      }
    };

    fetchCategories();
  }, []);

  useEffect(() => {
    const fetchPost = async () => {
      try {
        const response = await axios.get(`/api_w/posts/${id}`, {
          headers: {
            db_name: process.env.REACT_APP_DB_NAME,
          },
        });
        const postData = response.data.data;
        const date = new Date(postData.date);
        const formattedDate = `${date.getFullYear()}-${String(
          date.getMonth() + 1
        ).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}T${String(
          date.getHours()
        ).padStart(2, "0")}:${String(date.getMinutes()).padStart(2, "0")}`;
        setFormData({
          title: postData.title,
          description: postData.description,
          image: postData.image,
          date: formattedDate,
          category_id: postData.category_id,
          status: String(postData.status),
        });
      } catch (error) {
        toast.error(
          "Error fetching posts data: " +
            (error.response?.data?.message || error.message)
        );
      }
    };

    fetchPost();
  }, [id]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (file) {
      try {
        const uploadData = new FormData();
        uploadData.append("file", file);

        const response = await axios.post(`/api_w/upload/single`, uploadData, {
          headers: {
            db_name: process.env.REACT_APP_DB_NAME,
          },
        });
        setFormData((prevData) => ({
          ...prevData,
          image: response.data.data.Location,
        }));
      } catch (error) {
        toast.error(
          "Error Upload Gambar: " +
            (error.response?.data?.message || error.message)
        );
      }
    }
  };

  const handleDescriptionChange = (event, editor) => {
    const data = editor.getData();
    setFormData((prevData) => ({
      ...prevData,
      description: data,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await axios.put(`/api_w/posts/${id}`, formData, {
        headers: {
          Authorization: `${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
          db_name: process.env.REACT_APP_DB_NAME,
        },
      });
      console.log(response.data);
      toast.success("Berhasil Edit Postingan!");
      navigate("/admin/posts");
    } catch (error) {
      toast.error(
        "Error Edit Postingan: " +
          (error.response?.data?.message || error.message)
      );
    }
  };

  return (
    <div className="mt-5 px-2">
      <div className="mb-6">
        <h2 className="text-2xl font-bold text-navy-700 dark:text-white">Edit Postingan</h2>
        <p className="text-sm text-gray-500 mt-1">Perbarui konten postingan</p>
      </div>
      <div className="rounded-2xl bg-white shadow-sm p-6 dark:bg-navy-700">
        <form onSubmit={handleSubmit} className="space-y-5">
          <div>
            <label className="mb-1.5 block text-sm font-semibold text-navy-700 dark:text-white">Judul</label>
            <input
              type="text" name="title" value={formData.title} onChange={handleChange}
              className="block w-full rounded-xl border border-gray-200 bg-gray-50 px-4 py-2.5 text-sm text-gray-700 outline-none focus:border-brand-500 focus:ring-1 focus:ring-brand-500"
              required
            />
          </div>
          <div>
            <label className="mb-1.5 block text-sm font-semibold text-navy-700 dark:text-white">Deskripsi</label>
            <CKEditor
              editor={ClassicEditor}
              config={{ extraPlugins: [CustomUploadAdapterPlugin] }}
              data={formData.description}
              onChange={handleDescriptionChange}
            />
          </div>
          <div>
            <label className="mb-1.5 block text-sm font-semibold text-navy-700 dark:text-white">Gambar</label>
            {formData.image && (
              <div className="mb-2 overflow-hidden rounded-xl">
                <img src={formData.image} alt={formData.title} className="h-48 w-full object-cover" />
              </div>
            )}
            <input type="file" name="image" onChange={handleFileChange}
              className="block w-full rounded-xl border border-gray-200 bg-gray-50 px-3 py-2 text-sm text-gray-600 file:mr-3 file:rounded-lg file:border-0 file:bg-brand-50 file:px-3 file:py-1.5 file:text-xs file:font-medium file:text-brand-600"
            />
            <span className="mt-1 block text-xs text-gray-400">*Max 5MB — .png, .jpg, .jpeg, .svg, .webp</span>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
            <div>
              <label className="mb-1.5 block text-sm font-semibold text-navy-700 dark:text-white">Tanggal</label>
              <input type="datetime-local" name="date" value={formData.date} onChange={handleChange}
                className="block w-full rounded-xl border border-gray-200 bg-gray-50 px-4 py-2.5 text-sm text-gray-700 outline-none focus:border-brand-500 focus:ring-1 focus:ring-brand-500"
                required
              />
            </div>
            <div>
              <label className="mb-1.5 block text-sm font-semibold text-navy-700 dark:text-white">Kategori</label>
              <select name="category_id" value={formData.category_id} onChange={handleChange}
                className="block w-full rounded-xl border border-gray-200 bg-gray-50 px-4 py-2.5 text-sm text-gray-700 outline-none focus:border-brand-500 focus:ring-1 focus:ring-brand-500"
                required
              >
                <option value="" disabled>Pilih Kategori</option>
                {categories.map((cat) => (
                  <option key={cat.id} value={cat.id}>{cat.name}</option>
                ))}
              </select>
            </div>
          </div>
          <div>
            <label className="mb-1.5 block text-sm font-semibold text-navy-700 dark:text-white">Status</label>
            <select name="status" value={formData.status} onChange={handleChange}
              className="block w-full rounded-xl border border-gray-200 bg-gray-50 px-4 py-2.5 text-sm text-gray-700 outline-none focus:border-brand-500 focus:ring-1 focus:ring-brand-500"
              required
            >
              <option value="">Pilih Status</option>
              <option value="true">Aktif</option>
              <option value="false">Non-Aktif</option>
            </select>
          </div>
          <div className="flex justify-end gap-3 pt-2">
            <button type="button" onClick={() => navigate("/admin/posts")}
              className="rounded-xl border border-gray-200 px-6 py-2.5 text-sm font-medium text-gray-600 hover:bg-gray-50 transition-colors"
            >
              Batal
            </button>
            <button type="submit"
              className="rounded-xl px-6 py-2.5 text-sm font-bold text-white shadow-sm transition-colors"
              style={{ background: "linear-gradient(to right, #16a34a, #15803d)" }}
            >
              Simpan Perubahan
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditPost;
